import { state } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export const initialState = () => ({
  ...state,
  isEditing: false,
  leadToEditId: null,
  selectedLead: null,
  lead: {
    type: "",
    document: "",
    name: "",
    birthDate: "",
    mainPhone: "",
    secondaryPhone: "",
    email: "",
    cep: "",
    street: "",
    number: "",
    noNumber: false,
    complementType: "",
    complement: "",
    neighborhood: "",
    state: "",
    stateId: "",
    city: "",
    cityId: "",
    status: null,
    tags: [],
    note: "",
  },
  disabledFieldToEdit: {
    type: false,
    document: false,
    name: false,
    birthDate: false,
    mainPhone: false,
    secondaryPhone: false,
    email: false,
    cep: false,
    street: false,
    number: false,
    complementType: false,
    complement: false,
    neighborhood: false,
    state: false,
    city: false,
    referencePoint: false,
    status: false,
    tags: false,
    note: false,
  },
  currentStep: 0,
  polling: null,
  lastImportation: null
})
